<template>
    <div class="calendar">
        <el-alert
            title="Calendario no disponible"
            type="info"
            :closable="false"
            description="Este tipo de porlet (Calendar) ya no está soportado. Use el porlet Calendario en su lugar."
            show-icon
        />
    </div>
</template>

<script>
export default {
    name: 'Calendar'
}
</script>

<style lang="scss">
.calendar {
    padding: 0.5rem;
}
</style>
